import mapboxgl from "mapbox-gl";
import { CoamAreaFeature } from "../api/coamArea";
import { useRagMarkersLayer } from "../hooks/useRagMarkersLayer";

interface RagMarkersLayerProps {
  map: mapboxgl.Map | null;
  features: CoamAreaFeature[];
}

export const RagMarkersLayer = ({ map, features }: RagMarkersLayerProps) => {
  useRagMarkersLayer({ map, features });
  return null;
};

